/* src/app/intern/intern-details/general-info/general-info.component.scss */
mat-form-field {
  width: 220px;
}
mat-form-field.federal-date {
  width: 340px;
}
mat-form-field.long-w {
  width: 100%;
}
mat-form-field.suffix {
  width: 100px;
}
.title {
  font-size: 18px;
  background-color: #F4F0E5;
  color: black;
  height: 40px;
  margin: 0px;
  padding: 10px;
}
button {
  margin-left: 5px;
}
.delete-button {
  width: 80px;
}
.email-phone-header {
  background-color: #F4F0E5;
  margin: 40px;
  padding: 40px;
  width: 100%;
  height: 40px;
  text-align: left;
}
.email-phone-text {
  padding: 10px;
  font-size: 18px;
  color: #00004A;
  font-weight: normal;
}
.loading-indicator-section {
  padding: 100px;
}
.loading-indicator-section .spinner {
  margin: 0 auto;
}
.warning-msg {
  color: red;
}
.doNotEmail {
  padding-top: 40px;
}
.primary-required-msg {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}
.auth-email-legend {
  color: red;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.4;
  padding: 0 16px;
}
.submit-progress-bar {
  width: 83px;
  margin-top: -3px;
  margin-left: 5px;
  border-radius: 2px;
}
/*# sourceMappingURL=general-info.component.css.map */
